import React from 'react'
import classNames from 'classnames'
import { useIsSmallerThan } from 'src/hooks/useIsSmallerThan'
import totalClasses from './Total.module.scss'

const Total = ({ type = 'small', title, amount }) => {
    const isXSmall = useIsSmallerThan(480)

    const Wrapper = ({ children, ...props }) => {
        switch (type) {
            case 'small':
                return <h3 {...props}>{children}</h3>
            case 'big':
                return <h2 {...props}>{children}</h2>
            case 'red':
                return <h4 {...props} className={totalClasses.red}>{children}</h4>
        }
    }

    return (
        <div
            className={classNames(
                'align-right',
                'grid-wrapper-13',
                'grid-wrapper-100',
                totalClasses.footer
            )}>
            <div className={`col-${isXSmall ? 2 : 4}`}>&nbsp;</div>
            <div className={`col-${isXSmall ? 6 : 5}`}>
                <Wrapper>{`${title}: `}</Wrapper>
            </div>
            <div className={`col-${isXSmall ? 5 : 4}`}>
                <Wrapper
                    style={{ fontFamily: 'monospace' }}>
                    {`$${amount.toFixed(2)}`}
                </Wrapper>
            </div>
        </div>
    )
}

export default Total
